import * as React from 'react';
import { useParams } from 'react-router-dom';
import { P } from '../../../designSystem/typography/Body';
import { clientAccessHelper } from '../../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../../_pageWrappers/MemberPageWrapper';
import MeetingActivityPageView from '../../_components/activities/MeetingActivityPageView';
import { pageGuides } from '../../_guides/pageGuides';

export default function WorkgroupMeetingPage(): JSX.Element {
    const [activityTitle, setActivityTitle] = React.useState('');

    React.useEffect(() =>
    {
        document.title = 'Amorgy - AMO møde';
    }, []);
    
    return (
        <MemberPageWrapper
            selectedMenuItemKey="workgroupmeeting"
            guide={pageGuides.workgroupMeeting}
            breadCrumbs={[
                {text:'AMO møder', url:'/workgroupmeetings'},
                ...(activityTitle ? [{text:activityTitle, url:''}] : [])
            ]}>
            <WorkgroupMeetingPageContent onActivityTitleChanged={setActivityTitle} />
        </MemberPageWrapper>
    );
}

type WorkgroupMeetingPageContentProps = {
    onActivityTitleChanged:(title:string) => void,
}

function WorkgroupMeetingPageContent(props:WorkgroupMeetingPageContentProps): JSX.Element
{
    const params = useParams<{ activityId: string }>();
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['ViewActivity']);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return params.activityId 
        ? <MeetingActivityPageView activityId={params.activityId} onActivityTitleChanged={props.onActivityTitleChanged} />
        : <span>ugyldig url</span>;
}
